module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Give Before Getting and Joint Venture Partnerships Done Right")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "ch-aut"
  }, [_vm._v("by Brian G. Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In 2008, I made a decision that changed my life in ways I could never have imagined. I decided to enter the Internet marketing space with the goal of sharing my Internet marketing ideas, strategies, and tactics that allowed me to escape my day job in 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two years later I earned $452,000 in profit—not gross revenue, mind you, but profit. I share this not to brag, but rather to highlight the fact that what I’m about to reveal is based on personal experience. I could not have achieved this level of success without partnering and working strategically with others. I’ll discuss how to super charge your results by partnering with others and giving before getting.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("First things first, know this: the success you desire is not hard to achieve. It’s not hard at all, in fact. You don’t need to be the smartest person in the room, you don’t have to have a technical degree, a PhD, a fancy-pants license, or be a "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("New York Times")]), _vm._v(" best-selling author. Of course, these accolades are great. But they’re ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("not necessary to achieve incredible financial results. I certainly didn’t have any of these things.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Furthermore, what I’m about to share can be used by anyone regardless of race, religion, creed, or experience (or lack thereof) to absolutely crush it online. Millions and millions of incredibly successful, wealthy online entrepreneurs have not yet arrived. They are, however, staking their claim and forging a path to greatness. I invite you to decide right now that you’re one of those undiscovered rock stars. I did it, Joel Comm did it, and so have many of my coaching students.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now it’s your turn, and in the coming pages I’ll share with you the exact steps I took to develop powerful, strategic partnerships. It’s financial success, in a nutshell.")]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("• • • • •")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("In my humble opinion, the most important elements of success are believing it’s possible, having clarity in how you’ll deliver assets, and taking focused, daily actions to publish those assets.")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_vm._v("• • • • •")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s it. Do that, and you’ll be a massive success.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 2008, I launched a blog that led to releasing my first product to the market. The focus of both was leveraging expired domains in a unique way that made it fairly easy to make money.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How I launched that first product led to sales, future joint venture partners, a highly responsive list, engagement with those in my community, and more. All the ingredients that lead to success. Mind you, I did this starting from ground zero, and you can, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Looking back, it was clear that I focused on two fundamentals that I live by today: to figure out what people want (and then to give it to them), and giving before getting. They’re pretty simple concepts that may sound easy to do, but they’re not so easy, and frankly, most do not do them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Food for thought: marketing is about connecting with and working with people in numerous ways. You’ll be asking people to sign up, share, buy, and review what you publish—whether it’s a blog post, a Facebook status update, a software product, or a Kindle e-book.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("You’ll also be connecting and working with colleagues and partners. You’ll support their efforts, and in return they’ll support yours. Know this: it’s much more difficult to achieve high-level success without the support of other successful entrepreneurs. That means you’ll want to ask for their help. How you ask will make or break a potential lucrative partnership.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Partners who will share your product with their tribe can literally change your life overnight, but actually getting successful marketers to support your efforts takes planning, finesse, and outside-the-box thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many marketers get this wrong. They see the prize, they move forward in desperation or without really thinking through their actions, and they make a total mess of things. Here’s why. Those who are brand new have not proven themselves, they have not yet developed a trusted personal brand, and they can’t reciprocate with the same impact as someone who already has an established business online. Furthermore, highly successful marketers already work with others they know, like, and trust. They find partners who have the ability to drive substantial business back their way when it’s their turn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why should they support you? Why should they take a risk on someone who has not yet proven himself? It’s imperative that you give potential partners a good reason why, before asking for anything. When you’re just starting out, don’t make the rookie mistake of asking someone you have yet to build rapport with to support you. Instead, do something that addresses their needs and wants first. Give before getting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These are the steps I took to do just that. Earlier I mentioned I started a blog prior to the launch of my first product. I had come up with a unique strategy for expired domains and I simply started sharing that strategy. That is, I was giving before getting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wasn’t selling, nor setting up a prelaunch, but rather focusing on the needs and wants of those around me. First, I freely gave my ideas and tactics. Then, I offered a way for those interested to access more information either by signing up to a list or buying my product.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a few months the blog had established a following. It was not a huge number of people but a core group of highly interested folks. I gave them what they wanted and they returned for more ‘Brian G’ strategies again and again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Around this time I released a three-part series called Revenue Domains. The first post in the series was a hit, and people commented, engaged, and left their excitement for the next installment.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("During this time, I thought that this topic would make for a great info product, and I asked my readers if they would be interested. They responded positively, so I took what I shared in the blog series, expanded it, and launched it as a product.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Day 1 of my launch, many of my readers purchased, and I was well on my way. I had launched a blog that was driving traffic and building a list, and I had created videos on the same topic, which were also driving traffic via YouTube. I had begun to build my personal brand and was establishing trust with my audience. I had done this with no joint venture partners, no ad budget, no elaborate marketing strategy. Rather, I simply focused on the needs and wants of others to kick-start my brand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was my springboard. I had a product, buyers, a list, and assets that I could strategically leverage, and that’s exactly what I did. I then asked myself, “What is it that my subscribers want, and do I know any marketers who could fill that need?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I did not focus on getting hundreds of partners onboard for my next launch, but rather focused on establishing relationships with other marketers I trusted. Then I approached them about setting up a promotion for their product. That is, I would promote their product to my list of subscribers and buyers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, nearly all the potential partners I approached loved the idea. Instead of the usual “Will you promote my product?” pitch, I asked to promote theirs. Give before getting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The results?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I provided my subscribers with products I believed in and that were well-suited to their needs. Thus, my subscribers won, and in the process I was able to generate sizable affiliate commissions and most of the partners asked what type of products I had available.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bingo.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("After launching my third product, Commission Ritual, I remember thinking that an easy-to-use keyword research tool would be well-received by my buyers and subscribers. I contacted James Jones, a high level marketer with a sizable list ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("and the creator of a great keyword research tool. I asked to have a webinar with him to demo his software and its usage to my audience.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This resulted in awesome earnings for both James and me, and during that webinar, James asked what kinds of products I had. In the next 30 days, James and I ran two webinars for my product. Ka BOOM!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Find what people want and give it to them, and give before getting. These simple strategies can take you very far in your business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before I leave you, understand that some potential partners may make a mess of things themselves. You’ll send them business, leads, and money, and they may not reciprocate. If you continue on this path and give, however, you’ll find that you’re rewarded in other ways, sometimes by people who contact YOU to support your product.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Expect bumps in the road, but enjoy the journey. Because that’s what life and business are really all about. The everyday journey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Best,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brian G. Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("People do not fail at Internet marketing, they simply give up before the magic happens.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/page10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Brian G. Johnson is a serial entrepreneur who is also an engaging speaker, product creator, #1 best-selling author, nurturing mentor, and passionate poodle wrangler. Since 2008, Brian has coached tens of thousands of wealth seekers, many of whom are successfully generating life-changing income.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brian’s high energy and zest for life translate well into his coaching programs, where he breaks down the most important elements characteristic to many profitable online businesses—traffic and conversions. His formulas are simple, his rituals are effective, and his techniques are rather easy to follow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Learn more about Brian and his powerful Internet marketing strategies at:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('span', {
    staticClass: "underline"
  })]), _c('a', {
    attrs: {
      "href": "http://MarketingEasyStreet.com",
      "target": "_blank"
    }
  }, [_vm._v("MarketingEasyStreet.com")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Facebook: "), _c('span', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "href": "http://facebook.com/marketingeasystreet",
      "target": "_blank"
    }
  }, [_vm._v("facebook.com/marketingeasystreet")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("YouTube: "), _c('span', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "href": "http://YouTube.com/user/marketingeasyst",
      "target": "_blank"
    }
  }, [_vm._v("YouTube.com/user/marketingeasyst")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Google+: "), _c('span', {
    staticClass: "underline"
  })]), _c('a', {
    attrs: {
      "href": "http://plus.google.com/u/0/+BrianGJohnson-MarketingEasySt",
      "target": "_blank"
    }
  }, [_vm._v("plus.google.com/u/0/+BrianGJohnson-MarketingEasySt")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Twitter: "), _c('span', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "href": "http://twitter.com/@marketingeasystreet",
      "target": "_blank"
    }
  }, [_vm._v("@marketingeasystreet")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83fcbcfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter02.vue
// module id = 81
// module chunks = 0